var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      staticClass: "view-container",
      attrs: {
        form: _vm.form,
        rules: _vm.rules,
        "label-width": "150px",
        width: "650px",
      },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("settingAuthorize.addAndEdit.authorized"))),
      ]),
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingAuthorize.addAndEdit.logistics"),
                prop: "logisticsCompanyId",
              },
            },
            [
              _c("BjSelectLogisticCompany", {
                attrs: {
                  "default-options": {
                    label: _vm.form.logisticsCompanyName,
                    value: _vm.form.logisticsCompanyId,
                  },
                },
                on: { change: _vm.onLogistic },
                model: {
                  value: _vm.form.logisticsCompanyId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "logisticsCompanyId", $$v)
                  },
                  expression: "form.logisticsCompanyId",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingAuthorize.addAndEdit.business"),
                prop: "logisticsBusinessId",
              },
            },
            [
              _c("BjSelectLogisticBusiness", {
                attrs: {
                  disabled: !_vm.form.logisticsCompanyId,
                  "default-params": _vm.defaultParams,
                  "default-options": {
                    label: _vm.form.logisticsBusinessName,
                    value: _vm.form.logisticsBusinessId,
                  },
                  placeholder: _vm.form.logisticsCompanyId
                    ? _vm.$t("chooseText")
                    : _vm.$t("settingAuthorize.addAndEdit.logisticsText"),
                },
                on: { change: _vm.onBusiness },
                model: {
                  value: _vm.form.logisticsBusinessId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "logisticsBusinessId", $$v)
                  },
                  expression: "form.logisticsBusinessId",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingAuthorize.addAndEdit.interface"),
                prop: "interfaceType",
              },
            },
            [
              _c("BjSelectLov", {
                attrs: { "lov-code": "STHI.INTERFACE_TYPE" },
                model: {
                  value: _vm.form.interfaceType,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "interfaceType", $$v)
                  },
                  expression: "form.interfaceType",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingAuthorize.addAndEdit.channel"),
                prop: "channelList",
              },
            },
            [
              _c("BjSelectLov", {
                attrs: { multiple: "", "lov-code": "SCHL.CHANNEL_TYPE" },
                on: { change: _vm.onChannelList },
                model: {
                  value: _vm.form.channelList,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "channelList", $$v)
                  },
                  expression: "form.channelList",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingAuthorize.addAndEdit.authorizeTitle"),
                prop: "shopId",
              },
            },
            [
              _c("BjSelectStoreOnline", {
                attrs: { "default-params": { status: true, authStatus: 2 } },
                model: {
                  value: _vm.form.shopId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "shopId", $$v)
                  },
                  expression: "form.shopId",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.form.defaultFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "defaultFlag", $$v)
                    },
                    expression: "form.defaultFlag",
                  },
                },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        placement: "top-start",
                        content: _vm.$t(
                          "settingAuthorize.addAndEdit.tooltipText"
                        ),
                      },
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  ),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("settingAuthorize.addAndEdit.defaultType"))
                  ),
                ],
                1
              ),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.form.autoGetLogisticsNo,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "autoGetLogisticsNo", $$v)
                    },
                    expression: "form.autoGetLogisticsNo",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("settingAuthorize.addAndEdit.shipment")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      [
        _c(
          "BjDivider",
          {
            scopedSlots: _vm._u([
              {
                key: "right",
                fn: function () {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAddStore },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("settingAuthorize.addAndEdit.addWarehouse")
                          )
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _vm._v(
              " " +
                _vm._s(_vm.$t("settingAuthorize.addAndEdit.useWarehouse")) +
                " "
            ),
          ]
        ),
        _c(
          "el-table",
          { attrs: { data: _vm.form.warehouseList, script: "", border: "" } },
          [
            _c("el-table-column", {
              attrs: {
                type: "index",
                label: _vm.$t("table.countText"),
                align: "center",
                width: "60",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "warehouseCode",
                label: _vm.$t(
                  "settingAuthorize.addAndEdit.table.warehouseCode"
                ),
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "warehouseName",
                label: _vm.$t(
                  "settingAuthorize.addAndEdit.table.warehouseName"
                ),
                align: "center",
              },
            }),
          ],
          1
        ),
      ],
      _vm.isShowTableEndPrintData
        ? [
            _c("BjDivider", [
              _vm._v(
                _vm._s(_vm.$t("settingAuthorize.addAndEdit.interfaceMsg")) + " "
              ),
            ]),
            _c(
              "el-table",
              { attrs: { data: _vm.tableData, script: "", border: "" } },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "branchCode",
                    label: _vm.$t("settingAuthorize.addAndEdit.table.code"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "branchName",
                    label: _vm.$t("settingAuthorize.addAndEdit.table.name"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "monthlyCardNumber",
                    label: _vm.$t(
                      "settingAuthorize.addAndEdit.table.cardNumber"
                    ),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "deliveryAddress",
                    label: _vm.$t("settingAuthorize.addAndEdit.table.address"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "quantity",
                    label: _vm.$t(
                      "settingAuthorize.addAndEdit.table.electronicForm"
                    ),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "defaultAddress",
                    label: _vm.$t(
                      "settingAuthorize.addAndEdit.table.defaultAddress"
                    ),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "serviceBusiness",
                    label: _vm.$t("settingAuthorize.addAndEdit.table.business"),
                    align: "center",
                  },
                }),
              ],
              1
            ),
            _c(
              "BjDivider",
              {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "right",
                      fn: function () {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: { click: _vm.onDownload },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "settingAuthorize.addAndEdit.downloadPrint"
                                  )
                                )
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3326404891
                ),
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("settingAuthorize.addAndEdit.print")) + " "
                ),
              ]
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.span } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "settingAuthorize.addAndEdit.standardTemplate"
                      ),
                      prop: "printCloudStandardTemplateName",
                    },
                  },
                  [
                    _c("BjSelectLov", {
                      attrs: {
                        "option-list": _vm.standardTemplateOptions,
                        "item-value": "name",
                        loading: _vm.templateLoading,
                      },
                      on: { change: _vm.changeStandardTemplate },
                      model: {
                        value: _vm.form.printCloudStandardTemplateName,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "printCloudStandardTemplateName",
                            $$v
                          )
                        },
                        expression: "form.printCloudStandardTemplateName",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.span } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "settingAuthorize.addAndEdit.printTemplate"
                      ),
                      prop: "printCloudDefTemplateName",
                    },
                  },
                  [
                    _c("BjSelectLov", {
                      attrs: {
                        "option-list": _vm.defTemplateOptions,
                        "item-value": "name",
                        disabled: !_vm.form.printCloudStandardTemplateName,
                        loading: _vm.templateLoading,
                      },
                      on: { change: _vm.changeDefTemplate },
                      model: {
                        value: _vm.form.printCloudDefTemplateName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "printCloudDefTemplateName", $$v)
                        },
                        expression: "form.printCloudDefTemplateName",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.span } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("settingAuthorize.addAndEdit.sender"),
                      prop: "sender",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                        placeholder: _vm.$t("inputText"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.sender,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "sender", $$v)
                        },
                        expression: "form.sender",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.span } },
              [
                _c("BjFormItemMobile", {
                  attrs: {
                    label: _vm.$t("settingAuthorize.addAndEdit.sendMobile"),
                    prop: "senderPhone",
                    required: true,
                  },
                  model: {
                    value: _vm.form.senderPhone,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "senderPhone", $$v)
                    },
                    expression: "form.senderPhone",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 22 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-bottom": "0" },
                    attrs: {
                      label: _vm.$t("settingAuthorize.addAndEdit.sendAddress"),
                      prop: "fullAddress",
                    },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("BjRegionCascader", {
                          staticClass: "full-width",
                          attrs: { "is-array": "", clearable: "" },
                          on: { change: _vm.onChangeRegionCascader },
                          model: {
                            value: _vm.regionList,
                            callback: function ($$v) {
                              _vm.regionList = $$v
                            },
                            expression: "regionList",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 13 } },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t(
                              "settingAuthorize.addAndEdit.address"
                            ),
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.address,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "address", $$v)
                            },
                            expression: "form.address",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 22 } },
              [
                _c("el-form-item", [
                  _c(
                    "span",
                    {
                      staticClass: "red",
                      staticStyle: { "font-size": "12px" },
                    },
                    [_vm._v(_vm._s(_vm.$t("settingAuthorize.addAndEdit.tips")))]
                  ),
                ]),
              ],
              1
            ),
          ]
        : _vm._e(),
      _c("BjDialogList", {
        ref: "warehouse",
        attrs: {
          multiple: "",
          "row-keys": "code",
          config: _vm.$BjDialogListConfig.stockWarehouseLogic(),
        },
        on: { confirm: _vm.onConfirmWarehouseList },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }